import React from "react";
import { connect } from "react-redux";
import { authFetch } from "../../utils/api";
import { logoutUser } from "../../actions/authAction";
import IntelLogo from "../../static/img/Intel.png";
import KMVLogo from "../../static/img/kmv.png";
import AIFCLogo from "../../static/img/aifclogo.svg";
import styled from "styled-components";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";

const Logo = styled.img`
  width: auto;
  max-width: 100%;
  height: auto !important;
  max-height: 60px;
`;

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      selectedCertificateProgram:
        localStorage.getItem("selectedCertificateProgram") || "impact_fest",
      openTree: null,
    };
  }

  getProfile = () => {
    const id = localStorage.getItem("studentId");
    authFetch(`${process.env.REACT_APP_API_URL}/users/students/` + id)
      .then((res) => res.json())
      .then(
        (result) => {
          this.setState({
            isLoaded: true,
            data: result.data,
          });
        },
        (error) => {
          this.setState({
            isLoaded: true,
            error,
          });
        }
      );
  };

  componentDidMount() {
    this.getProfile();
  }

  render() {
    return (
      <React.Fragment>
        <div className="position-fixed w-100 header-wrapper">
          <div className="header-container ">
            <div className="row header-logos-container content-container py-md-2">
              <div className="col-4 header-col d-flex align-items-center justify-content-start">
                <Logo className="header-logo" src={KMVLogo} alt="KMVLogo" />
              </div>
              <div className="col-4 header-col d-flex align-items-center justify-content-center">
                <Logo
                  className="header-logo aisc-logo"
                  src={AIFCLogo}
                  alt="AI Facilitator Community"
                />
              </div>
              <div className="col-4 header-col d-flex align-items-center justify-content-end">
                <Logo
                  className="header-logo intel-logo p-md-2"
                  src={IntelLogo}
                  alt="IntelLogo"
                />
              </div>
            </div>
          </div>

          {!this.props.hideSubHeader && (
            <header className="header px-2 px-md-0">
              <nav
                className={
                  "navbar navbar-expand-lg py-0  " +
                  (this.props.bgColor && this.props.bgColor === "white"
                    ? "custom-nav white-bg"
                    : "")
                }
              >
                <div className="container">
                  <ul style={{ display: "contents" }}>
                    <li className="nav-item">
                      <a className="nav-link page-scroll" href="/dashboard">
                        Home
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link page-scroll" href="/letslearn">
                        Let's Learn
                      </a>
                    </li>
                    <li className="dropdown" style={{ marginTop: 0 }}>
                      <a
                        href="#"
                        className="nav-link page-scroll"
                        id="learningResourcesDropdownMenu"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        Events
                      </a>
                      <div
                        className="dropdown-menu dropdown-menu-lg-right"
                        aria-labelledby="learningResourcesDropdownMenu"
                      >
                        <a href="/event" className="dropdown-item">
                          Weekly Sessions
                        </a>
                        <a href="/challenge" className="dropdown-item">
                          Challenges
                        </a>
                        <a
                          href={process.env.REACT_APP_FORUM_URL}
                          className="dropdown-item"
                        >
                          Forum
                        </a>
                      </div>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link page-scroll" href="/blog">
                        Blogs
                      </a>
                    </li>
                    <li className="nav-item dropdown">
                      <a
                        href="#"
                        className="nav-link"
                        id="learningResourcesDropdown"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        Learning Resources
                      </a>
                      <div
                        className="dropdown-menu tree-dropdown"
                        aria-labelledby="learningResourcesDropdown"
                      >
                        {/* AI Curriculum */}
                        <div>
                          <div
                            className="tree-parent"
                            onClick={() =>
                              this.setState({
                                openTree:
                                  this.state.openTree === "curriculum"
                                    ? null
                                    : "curriculum",
                              })
                            }
                          >
                            <a href="#" className="dropdown-item tree-parent">
                              <span>AI Curriculum</span>
                              <span className="arrow">
                                {this.state.openTree === "curriculum" ? (
                                  <FaChevronDown />
                                ) : (
                                  <FaChevronRight />
                                )}
                              </span>
                            </a>
                          </div>
                          {this.state.openTree === "curriculum" && (
                            <div className="tree-children">
                              <a
                                href="/learningResources#class-6-8"
                                className="dropdown-item"
                              >
                                Grade 6–8
                              </a>
                              <a
                                href="/learningResources#class-9"
                                className="dropdown-item"
                              >
                                Grade 9
                              </a>
                              <a
                                href="/learningResources#class-10"
                                className="dropdown-item"
                              >
                                Grade 10
                              </a>
                              <a
                                href="/learningResources#handbook"
                                className="dropdown-item"
                              >
                                Handbook
                              </a>
                              <a
                                href="/learningResources#sample-papers"
                                className="dropdown-item"
                              >
                                Sample Papers
                              </a>
                              <a
                                href="/learningResources#question-banks"
                                className="dropdown-item"
                              >
                                Question Bank
                              </a>
                            </div>
                          )}
                        </div>
                        <a href="/AIProjects" className="dropdown-item">
                          AI Projects
                        </a>

                        <a
                          href="https://ai-for-all.in"
                          target="_blank"
                          className="dropdown-item"
                        >
                          AI For All
                        </a>
                        <div>
                          <div
                            className="tree-parent"
                            onClick={() =>
                              this.setState({
                                openTree:
                                  this.state.openTree === "aiot"
                                    ? null
                                    : "aiot",
                              })
                            }
                          >
                            <a href="#" className="dropdown-item tree-parent">
                              <span>AIoT Integration</span>
                              <span className="arrow">
                                {this.state.openTree === "aiot" ? (
                                  <FaChevronDown />
                                ) : (
                                  <FaChevronRight />
                                )}
                              </span>
                            </a>
                          </div>
                          {this.state.openTree === "aiot" && (
                            <div className="tree-children">
                              <a
                                href="/lesson-plans#grade-vi"
                                className="dropdown-item"
                              >
                                Grade VI
                              </a>
                              <a
                                href="/lesson-plans#grade-vii"
                                className="dropdown-item"
                              >
                                Grade VII
                              </a>
                              <a
                                href="/lesson-plans#grade-viii"
                                className="dropdown-item"
                              >
                                Grade VIII
                              </a>
                              <a
                                href="/lesson-plans#grade-ix"
                                className="dropdown-item"
                              >
                                Grade IX
                              </a>
                              <a
                                href="/lesson-plans#grade-x"
                                className="dropdown-item"
                              >
                                Grade X
                              </a>
                            </div>
                          )}
                        </div>

                        {/* CBSE AI */}
                        <a
                          href="https://cbseacademic.nic.in/ai.html"
                          className="dropdown-item"
                        >
                          CBSE AI
                        </a>
                      </div>
                    </li>
                    <li className="nav-item dropdown">
                      <a
                        href="#"
                        className="nav-link"
                        id="indiaAIDropdown"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        Impact Festival
                      </a>
                      <div
                        className="dropdown-menu"
                        aria-labelledby="indiaAIDropdown"
                      >
                        <a
                          className="dropdown-item"
                          href="/india-ai-impact-festival-2024"
                        >
                          2024
                        </a>
                        <a
                          className="dropdown-item"
                          href="/india-ai-impact-festival-2025"
                        >
                          2025
                        </a>
                      </div>
                    </li>
                    <li className="nav-item dropdown">
                      <a
                        href="#"
                        className="nav-link"
                        id="aiEducatorsDropdown"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        AI for Educators
                      </a>
                      <div
                        className="dropdown-menu"
                        aria-labelledby="aiEducatorsDropdown"
                      >
                        <a
                          className="dropdown-item"
                          href="/ai-for-educators-2025"
                        >
                          2025
                        </a>
                      </div>
                    </li>
                    <li className="nav-item dropdown">
                      <a
                        href="#"
                        className="nav-link border-0 bg-transparent"
                        id="certificatesDropdown"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        Certificates
                      </a>
                      <div
                        className="dropdown-menu"
                        aria-labelledby="certificatesDropdown"
                      >
                        <a
                          className="dropdown-item"
                          href="/generate-certificate"
                          onClick={(e) => {
                            localStorage.setItem(
                              "selectedCertificateProgram",
                              "impact_fest"
                            );
                            this.setState({
                              selectedCertificateProgram: "impact_fest",
                            });
                          }}
                        >
                          Impact Festival
                        </a>
                        <a
                          className="dropdown-item"
                          href="/generate-certificate"
                          onClick={(e) => {
                            localStorage.setItem(
                              "selectedCertificateProgram",
                              "cbp"
                            );
                            this.setState({
                              selectedCertificateProgram: "cbp",
                            });
                          }}
                        >
                          Capacity Building Program
                        </a>
                      </div>
                    </li>
                  </ul>
                  <div
                    className="collapse navbar-collapse"
                    id="navbarSupportedContent"
                  >
                    <ul className="navbar-nav ml-auto py-1">
                      <li className="nav-item d-flex align-items-center">
                        <a className="nav-link page-scroll " href="/profile">
                          {this.state.data.map((item) => item.first_name)}
                        </a>
                      </li>
                      <li className="nav-item d-flex align-items-center">
                        <div className="dropdown">
                          <div
                            className="profile-picture"
                            style={{
                              backgroundImage: `url(${this.state.data.map(
                                (item) => item.profile_pic
                              )})`,
                            }}
                          ></div>

                          <div className="dropdown-content shadow">
                            <a href="/profile" style={{ color: "black" }}>
                              Profile{" "}
                            </a>

                            <div className="border-line"></div>
                            <a
                              href="/"
                              onClick={() => this.props.logoutUser()}
                              style={{ color: "black" }}
                            >
                              Logout
                            </a>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </nav>
            </header>
          )}
        </div>
      </React.Fragment>
    );
  }
}
const mapStateToProps = (state) => ({
  auth: state.auth,
});
export default connect(mapStateToProps, { logoutUser })(Header);
